import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../scss/entry.scss';
import { controlAnnouncement } from './controlAnnouncement';

jQuery(document).ready(function($) {

	// Set --nav-height CSS variable from actual masthead height
	function setNavHeight() {
		var h = document.getElementById('masthead');
		if (h) {
			document.documentElement.style.setProperty('--nav-height', (h.offsetHeight + 24) + 'px');
		}
	}
	// Run on DOMContentLoaded, after full load, and on resize
	setNavHeight();
	$(window).on('load resize', setNavHeight);

	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// simple accordions
	$('.simple-accordion-toggle').on('click', function(e) {
		$(this).toggleClass('accordion-active');
		$(this).siblings('.simple-accordion-content').slideToggle('fast');
	})

	// text accordions
	$('.text-accordion-toggle').on('click', function(e) {
		$(this).parent().toggleClass('accordion-active');
		$(this).siblings('.text-accordion-content').slideToggle('fast');
	})

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// Featured News
	const newsSwiper = document.querySelector(".featured-news__swiper");

	if (newsSwiper) {
		const newsSwiperSpeed = parseInt(newsSwiper.dataset.speed);
		const featuredNewsSwiper = new Swiper('.featured-news__swiper', {
			modules: [Autoplay, Pagination, Navigation],
			slidesPerView: 1,
			spaceBetween: 18,
			loop: true,
			navigation: {
				nextEl: ".featured-news__button-next",
				prevEl: ".featured-news__button-prev"
			},
			autoplay: {
				disableOnInteraction: true,
				delay: newsSwiperSpeed
			},
			pagination: {
				el: ".featured-news__dots"
			},
			breakpoints: {
				767: {
					slidesPerView: 2
				}
			}
		})
	}

	// news and events swiper
	const newsEventsSwiper = new Swiper('.news-events__news--mobile', {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
		autoplay: {
			disableOnInteraction: true
		},
		pagination: {
			el: ".news-events__dots"
		},
		breakpoints: {
			767: {
				slidesPerView: 0
			}
		}
	})

	// Resources accordion
	$(".resources__right--card-accordion-toggle").on("click", function(e) {
		$(this).toggleClass("accordion-active");
		$(this).siblings(".resources__right--card-accordion-links").slideToggle('fast');
	})
	
	$(".resources__quick-links--accordion-toggle").on("click", function(e) {
		$(this).toggleClass("accordion-active");
		$(this).siblings(".resources__quick-links--accordion-links").slideToggle('fast');
	})

	// fifty fifty image text accordion
	$(".ffit__content--accordion-toggle").on("click", function(e) {
		$(this).toggleClass('accordion-active');
		$(this).parent().siblings('.ffit__content--accordion-content').slideToggle("fast");
	})

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	// Desktop (>=860px): pure CSS :hover dropdowns, SmartMenus suppressed
	// Mobile (<860px):   SmartMenus accordion via hamburger
	$(function() {

		// Patch SmartMenus isCollapsible so it uses accordion mode below 860px
		// regardless of CSS position (our desktop dropdowns use display:none not position:static)
		var _smIsCollapsible = $.SmartMenus.prototype.isCollapsible;
		$.SmartMenus.prototype.isCollapsible = function() {
			return $(window).width() < 860 ? true : _smIsCollapsible.call(this);
		};

		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1,
			mainMenuSubOffsetX: 0,
			mainMenuSubOffsetY: 0,
			showTimeout: 0,
			hideTimeout: 200,
			keepInViewport: false,
			collapsibleBehavior: 'accordion'
		});

		// Desktop: suppress SmartMenus show/hide — CSS :hover handles dropdowns
		$('.primary-menu').on('sm.submenu.beforeshow sm.submenu.beforehide', function(e, $sub) {
			if ($(window).width() >= 860) {
				e.preventDefault();
				return false;
			}
		});

		// Desktop: clear any SmartMenus inline styles on resize up through breakpoint
		$(window).on('resize', function() {
				if ($(window).width() >= 860) {
					$('.primary-menu ul.sub-menu').each(function() {
						$(this).removeAttr('style').removeClass('sm-nowrap');
					});
				}
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				console.log('hit')
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));

	// Control Announcement Banner

	const announcementContainer = document.querySelector(".announcement__container");

	if (announcementContainer) {
		controlAnnouncement(announcementContainer);
	}

	// ── Sectioned Content ──────────────────────────────────────────────────────
	$(document).on('click', '.sc__accordion-grid--toggle', function() {
		var $toggle  = $(this);
		var $content = $toggle.next('.sc__accordion-grid--content');
		var expanded = $toggle.attr('aria-expanded') === 'true';
		$toggle.attr('aria-expanded', !expanded);
		$content.toggleClass('is-open');
	});

	$(document).on('click', '.sc__plan-accordion--toggle', function() {
		var $toggle  = $(this);
		var $content = $toggle.siblings('.sc__plan-accordion--content');
		var expanded = $toggle.attr('aria-expanded') === 'true';
		$toggle.attr('aria-expanded', !expanded);
		$content.toggleClass('is-open');
	});

	if ($('.sc__sidebar--nav').length) {
		var $navLinks    = $('.sc__sidebar--nav-link');
		var $navItems    = $('.sc__sidebar--nav-item');
		var $sections    = $('.sc__section');

		function getHeaderOffset() {
			var masthead = document.getElementById('masthead');
			return masthead ? masthead.offsetHeight + 24 : 120;
		}

		$navLinks.on('click', function(e) {
			e.preventDefault();
			var target  = $(this).attr('href');
			var $target = $(target);
			if ($target.length) {
				$('html, body').animate({ scrollTop: $target.offset().top - getHeaderOffset() }, 400);
			}
		});

		function updateActiveSidebarItem() {
			var headerOffset = getHeaderOffset();
			var current = '';
			$sections.each(function() {
				if ($(window).scrollTop() >= $(this).offset().top - headerOffset - 20) {
					current = '#' + $(this).attr('id');
				}
			});
			if (current) {
				$navItems.removeClass('is-active');
				$navLinks.filter('[href="' + current + '"]').closest('.sc__sidebar--nav-item').addClass('is-active');
			}
		}

		$(window).on('scroll', throttle(updateActiveSidebarItem, 100));
		updateActiveSidebarItem();
	}
});
